import { render, staticRenderFns } from "./InboundManagementPage.vue?vue&type=template&id=fbd44470&scoped=true"
import script from "./InboundManagementPage.vue?vue&type=script&lang=js"
export * from "./InboundManagementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd44470",
  null
  
)

export default component.exports